<template>
<Menu></Menu>
<div id="box">
  <div v-if="loading" class="loadingSpinner">
    <span class="spinner-border"></span>
  </div>
  <!-- =========================================================================================================== -->
  <div class="container mb-2">
    <!-- ---------------------------------------------------- -->
    <div class="row p-0">
      <div class="col p-0 text-center">
        <h5 class="fw-bold d-inline-block bi-graph-up-arrow">&nbsp; Statistics</h5>
        <hr />
      </div>
    </div>
    <!-- ---------------------------------------------------- -->
    <div class="row p-0">
      <div class="col-12 mb-3">
        <div class="card p-3">
          <div class="row mb-3">
            <div class="col-6">
              <div class="input-group w-100">
                <span class="input-group-text w-20">Branches</span>
                <multiselect v-model="filter.branches" :options="branches" :multiple="true" :showLabels="false" :close-on-select="false" track-by="_id" label="name" placeholder="Select Branches" :preselect-first="true" class="w-80"></multiselect>
                <!-- <Select2 class="w-75" v-model="most.branches" :options="this.branches" :settings="branches_select2_settings"/> -->
              </div>
            </div>
            <div class="col">
              <div class="input-group mb-2">
                <span class="input-group-text">From</span>
                <input class="form-control text-center" type="date" v-model="filter.from">
              </div>
            </div>
            <div class="col">
              <div class="input-group mb-2">
                <span class="input-group-text">To</span>
                <input class="form-control text-center" type="date" v-model="filter.to">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------------------------- -->
    <div class="row p-0">

      <div class="col-6 mb-3">

        <div class="card p-3">
          <div class="row">
            <div class="col">
              <p class="fw-bold fs-5">Most Sold Product</p>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getMostSold('quantity')">By Quantity</button>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getMostSold('value')">By Value</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-6 mb-3">

        <div class="card p-3">

          <div class="row">
            <div class="col">
              <p class="fw-bold fs-5 text-danger">Expenses</p>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getExpenses">Get</button>
            </div>
          </div>
        </div>


      </div>

      <div class="col-6 mb-3">

        <div class="card p-3">

          <div class="row">
            <div class="col">
              <p class="fw-bold fs-5 text-primary">Sales</p>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getSales('monthly')">Monthly</button>
            </div>
            <!-- <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getSales('weekly')">Weekly</button>
            </div> -->
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getSales('daily')">Daily</button>
            </div>
          </div>

        </div>


      </div>

      <div class="col-6 mb-3">

        <div class="card p-3">

          <div class="row">
            <div class="col">
              <p class="fw-bold fs-5 text-success">Revenue</p>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getRevenue('monthly')">Monthly</button>
            </div>
            <!-- <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getRevenue('weekly')">Weekly</button>
            </div> -->
            <div class="col-auto">
              <button class="btn btn-primary px-3" @click="getRevenue('daily')">Daily</button>
            </div>
          </div>

        </div>


      </div>

    </div>
    <!-- =========================================================================================================== -->
    <div id="mostSoldModal" ref="mostSoldModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Most Sold Product By {{ most.type }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">

            <div class="row">
              <div class="col">
                <div class="input-group mb-2">
                  <span class="input-group-text">Search</span>
                  <input class="form-control" type="text" v-model.trim="most.filter">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <table class="table table-sm table-bordered table-striped table-hover table-fixed">
                  <thead>
                    <tr class="table-dark">
                      <th class="w-10">Rank</th>
                      <th>Product</th>
                      <td v-if="most.type == 'value'">Value EGP</td>
                      <td v-else>Quantity</td>
                    </tr>
                  </thead>
                  <tbody style="height: 500px;">
                    <tr v-for="x in most_data_filtered" :key="x">
                      <th class="w-10">{{ x.rank }}</th>
                      <td>{{ x.product }}</td>
                      <td v-if="most.type == 'value'">{{ formatMoney(x.value) }}</td>
                      <td v-else>{{ x.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="expensesModal" ref="expensesModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Expenses</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">

            <div class="row">
              <div class="col">
                <table class="table table-sm table-bordered table-striped table-hover table-fixed">
                  <thead>
                    <tr class="table-dark">
                      <th class="w-10">Rank</th>
                      <th>Branch</th>
                      <td>Expenses</td>
                      <td>Transfer Fees</td>
                      <td>Total EGP</td>
                    </tr>
                  </thead>
                  <tbody style="height: 500px;">
                    <tr v-for="x in expenses.data" :key="x">
                      <th class="w-10">{{ x.rank }}</th>
                      <td>{{ x.branch }}</td>
                      <td>{{ formatMoney(x.expenses) }}</td>
                      <td>{{ formatMoney(x.transfers) }}</td>
                      <td>{{ formatMoney(x.value) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="salesModal" ref="salesModal" class="modal fade">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Sales</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="chart-container">
              <BarChart :chartData="sales.data" :options="sales.options"></BarChart>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="revenueModal" ref="revenueModal" class="modal fade">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Revenue</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="revenue-chart-tab" data-bs-toggle="tab" data-bs-target="#revenue-chart" role="tab">Chart</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="revenue-table-tab" data-bs-toggle="tab" data-bs-target="#revenue-table" role="tab">Table</button>
              </li>
            </ul>

            <div class="tab-content p-2">
              <!-- ******************************************************** -->
              <div class="tab-pane fade show active mb-5" id="revenue-chart">
                <div class="row">
                  <div class="col p-0">
                    <div class="chart-container">
                      <BarChart :chartData="revenue.data" :options="revenue.options"></BarChart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ******************************************************** -->
              <!-- ******************************************************** -->
              <div class="tab-pane fade mb-5" id="revenue-table">
                <div class="row">
                  <div class="col p-0">
                    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
                      <thead>
                        <tr class="table-dark">
                          <th>{{ { 'daily': 'Day', 'monthly': 'Month' }[revenue.type] }}</th>
                          <th>Sales</th>
                          <th>Cost</th>
                          <th>Expenses</th>
                          <th>Transfer Fees</th>
                          <th>Revenue</th>
                        </tr>
                      </thead>
                      <tbody style="height: 500px;">
                        <tr v-for="date, i in revenue.data.labels" :key="i">
                          <th>{{ date }}</th>
                          <td>{{ formatMoney(revenue.data.datasets[0].data[i]) }}</td>
                          <td>{{ formatMoney(revenue.data.datasets[1].data[i]) }}</td>
                          <td>{{ formatMoney(revenue.data.datasets[2].data[i]) }}</td>
                          <td>{{ formatMoney(revenue.data.datasets[3].data[i]) }}</td>
                          <td>{{ formatMoney(revenue.data.datasets[4].data[i]) }}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
              <!-- ******************************************************** -->
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <!-- ----------------------------------------------- -->
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- ---------------------------------------------------- -->
    <!-- ---------------------------------------------------- -->
    <!-- ---------------------------------------------------- -->
  </div>
</div>
</template>
<!-- ******************************************************** -->
<script>
const $ = require('jquery');
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
export default {
  name: "StatisticsPage",
  components: {
    BarChart
  },
  data() {
    return {
      loading: false,
      //-----------------------
      branches: [],
      //--------------------------
      branches_select2_settings: {
        theme: "bootstrap-5",
        placeholder: 'Select Branches',
        width: 'resolve',
        multiple: true,
      },
      //-----------------------
      filter: {
        branches: [],
        from: '',
        to: '',
      },
      most: {
        filter: '',
        type: 'quantity',
        data: [],
      },
      //-----------------------
      expenses: {
        data: [],
      },
      //-----------------------
      sales: {
        type: 'daily',
        data: {
          labels: [],
          datasets: [{
            label: 'Sales',
            backgroundColor: '#42A5F5',
            borderColor: '#1E88E5',
            borderWidth: 1,
            data: [],
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false, position: 'top' },
            tooltip: { enabled: true },
            // title: { display: true, text: 'Sales by days', font: { size: 16 } }
          },
          scales: {
            y: { beginAtZero: true, title: { display: true, text: 'Sales' } },
            x: { title: { display: true, text: 'Days' } },
          },
        },
      },
      //-----------------------
      revenue: {
        type: 'daily',
        data: {
          labels: [],
          datasets: [
            { label: 'Sales', backgroundColor: '#0d6efd', borderColor: '#0d6efd', borderWidth: 1, data: [] },
            { label: 'Cost', backgroundColor: '#dc3545', borderColor: '#dc3545', borderWidth: 1, data: [], stack: 'out' },
            { label: 'Expenses', backgroundColor: '#fd7e14', borderColor: '#fd7e14', borderWidth: 1, data: [], stack: 'out' },
            { label: 'Transfers', backgroundColor: '#ffc107', borderColor: '#ffc107', borderWidth: 1, data: [], stack: 'out' },
            { label: 'Revenue', backgroundColor: '#198754', borderColor: '#198754', borderWidth: 1, data: [] },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top' },
            tooltip: { enabled: true },
            // title: { display: true, text: 'Sales by days', font: { size: 16 } }
          },
          scales: {
            y: { beginAtZero: true, title: { display: true, text: 'Revenue' } },
            x: { title: { display: true, text: 'Days' } },
          },
        },

      },
      //-----------------------
      //-----------------------
    };
  },
  computed: {
    most_data_filtered() {
      if (!this.most.filter) return this.most.data;
      return this.most.data.filter((x) => x.product.toLowerCase().includes(this.most.filter.toLowerCase()));
    }
  },
  async created() {
    await this.loadBranches();
    this.filter.from = this.$getMonthStart();
    this.filter.from = '2024-01-01'
    this.filter.to = this.$getNextMonthStart();

    // this.filter.from = this.$getMonthStart();
    // this.filter.from = '2023-01-01'
    // this.filter.to = this.$getNextMonthStart();

    // this.filter.branches = this.branches;
  },
  methods: {
    //------------------------------------
    async loadBranches() {
      this.loading = true;
      this.branches = [];
      var ack = await this.$service.getBranchesAbstractV2();
      if (ack.state != 'OK') {
        this.$toast(ack.state);
      }
      else {
        this.branches = ack.data.branches;
      }
      this.loading = false;
    },
    //------------------------------------
    async getMostSold(type) {
      if (!this.filter.branches.length) {
        return this.$toast("Select at least 1 branch");
      }
      if (!this.filter.from || !this.filter.to) {
        return this.$toast("Select from, to dates");
      }
      this.loading = true;
      var getter = type == 'quantity' ? this.$service.getMostSoldByQuantity : this.$service.getMostSoldByValue;
      var ack = await getter({
        branches: JSON.stringify(this.filter.branches.map((x) => x._id)),
        from: this.filter.from,
        to: this.filter.to,
      });
      if (ack.state != 'OK') {
        this.$toast(ack.state);
      }
      else {
        this.most.type = type;
        this.most.data = ack.data;
        $('#mostSoldModal').modal('show');
      }
      this.loading = false;
    },
    //------------------------------------
    async getExpenses() {
      if (!this.filter.branches.length) {
        return this.$toast("Select at least 1 branch");
      }
      if (!this.filter.from || !this.filter.to) {
        return this.$toast("Select from, to dates");
      }
      this.loading = true;
      var ack = await this.$service.getExpensesStats({
        branches: JSON.stringify(this.filter.branches.map((x) => x._id)),
        from: this.filter.from,
        to: this.filter.to,
      });
      if (ack.state != 'OK') {
        this.$toast(ack.state);
      }
      else {
        this.expenses.data = ack.data;
        $('#expensesModal').modal('show');
      }
      this.loading = false;
    },
    //------------------------------------
    async getSales(type) {
      if (!this.filter.branches.length) {
        return this.$toast("Select at least 1 branch");
      }
      if (!this.filter.from || !this.filter.to) {
        return this.$toast("Select from, to dates");
      }
      this.sales.options.scales.x.title.text = {
        'daily': 'Days',
        'weekly': 'Weeks',
        'monthly': 'Months',
      }[type];
      this.loading = true;
      var ack = await this.$service.getSalesStats({
        branches: JSON.stringify(this.filter.branches.map((x) => x._id)),
        from: this.filter.from,
        to: this.filter.to,
        type: type,
      });
      if (ack.state != 'OK') {
        this.$toast(ack.state);
      }
      else {
        this.sales.data.labels = ack.data.map((x) => x.date);
        this.sales.data.datasets[0].data = ack.data.map((x) => x.value);
        $('#salesModal').modal('show');
      }
      this.loading = false;
    },
    //------------------------------------
    async getRevenue(type) {
      if (!this.filter.branches.length) {
        return this.$toast("Select at least 1 branch");
      }
      if (!this.filter.from || !this.filter.to) {
        return this.$toast("Select from, to dates");
      }
      this.sales.options.scales.x.title.text = {
        'daily': 'Days',
        'weekly': 'Weeks',
        'monthly': 'Months',
      }[type];
      this.loading = true;
      var ack = await this.$service.getRevenueStats({
        branches: JSON.stringify(this.filter.branches.map((x) => x._id)),
        from: this.filter.from,
        to: this.filter.to,
        type: type,
      });
      if (ack.state != 'OK') {
        this.$toast(ack.state);
      }
      else {
        this.revenue.data.labels = ack.data.map((x) => x.date);
        this.revenue.data.datasets[0].data = ack.data.map((x) => x.sales);
        this.revenue.data.datasets[1].data = ack.data.map((x) => x.cost);
        this.revenue.data.datasets[2].data = ack.data.map((x) => x.expenses);
        this.revenue.data.datasets[3].data = ack.data.map((x) => x.transfers);
        this.revenue.data.datasets[4].data = ack.data.map((x) => x.revenue);
        $('#revenueModal').modal('show');
      }
      this.loading = false;
    },
    //------------------------------------
    rgbToHex(r, g, b) {
      return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`
    },
    hexToRgb(hex) {
      if (!hex) return null;
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (!result) return null;
      return { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) };
    },
    generateColors(length) {
      if (length == 1) {
        return ['#FF0000'];
      }
      var spectrum = [];
      // var colors = [
      //   "#FF0000", // Red
      //   "#FFFF00", // Yellow
      //   "#00FF00", // Green
      //   "#0000FF", // Blue
      //   "#FF00FF"  // Magenta
      // ];
      var startColorHex = "#FF0000";
      var endColorHex = "#0000FF";
      const startRgb = this.hexToRgb(startColorHex);
      const endRgb = this.hexToRgb(endColorHex);
      for (let i = 0; i < length; i++) {
        const factor = i / (length - 1);

        spectrum.push(this.rgbToHex(
          Math.round(startRgb.r + factor * (endRgb.r - startRgb.r)),
          Math.round(startRgb.g + factor * (endRgb.g - startRgb.g)),
          Math.round(startRgb.b + factor * (endRgb.b - startRgb.b)),
        ));

      }
      return spectrum;
    }
    //------------------------------------
    //------------------------------------
  },
};
</script>
<!-- ******************************************************** -->
<style>
.select2-selection__choice {
  float: none !important;
  display: inline-block !important;
  /* color: #1ee528; */
}

.modal-xl {
  width: calc(100% - 50px) !important;
  max-width: 100% !important;
}

.chart-container canvas {
  position: relative !important;
  width: auto !important;
  height: 100% !important;
  max-height: 700px !important;
}
</style>
